<template>
<div class="container">
  <h1 class="mb-4" v-if="investor.type == 'Fisica'">{{ investor.fullname }}</h1>
  <h1 class="mb-4" v-else>{{ investor.corporate_name }}</h1>

  <div class="details">
    <div class="details__head">
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item tabs-item">
          <a class="nav-link active" data-toggle="tab" role="tab" href="#details"><fai icon="info"/>
            &nbsp;Generales
          </a>
        </li>
        <li class="nav-item tabs-item">
          <a class="nav-link" data-toggle="tab" role="tab" href="#bank_data"><fai icon="credit-card"/>
            &nbsp;Cuentas Bancarias
          </a>
        </li>
        <li class="nav-item tabs-item">
          <a class="nav-link" data-toggle="tab" role="tab" href="#contacts"><fai icon="address-book"/>
            &nbsp;Contactos
          </a>
        </li>
        <li class="nav-item tabs-item">
          <a class="nav-link" data-toggle="tab" role="tab" href="#documentation"><fai :icon="['far','folder-open']"/>
            &nbsp;Documentación
          </a>
        </li>
        <li class="nav-item tabs-item">
          <a class="nav-link" data-toggle="tab" role="tab" href="#investments"><fai :icon="['far','file']"/>
            &nbsp;Inversiones
          </a>
        </li>
        <li class="nav-item tabs-item">
          <a class="nav-link" data-toggle="tab" role="tab" href="#monthly-cuts"><fai icon="dollar-sign"/>
            &nbsp;Estados de Cuenta
          </a>
        </li>
      </ul>
    </div>
    <div class="details__body mt-4">
      <div class="tab-content">
        <!--begin: Details -->
        <div id="details" class="tab-pane fade show active" role="tabpanel" v-if="investor.id">
          <div class="row">
            <div class="col-sm-6">
              <h4 class="m--font-info">Datos Generales</h4>
            </div>
            <div class="col-sm-6 text-right">
              <button class="btn btn-info" @click="goToEdit">
                <fai :icon="['far','edit']"/> Editar
              </button>
              <button class="btn btn-danger" @click="deleteInvestor">
                <fai icon="trash"/> Eliminar
              </button>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-sm-12">
              <h5>Descripción</h5>
              <span>{{ investor.description }}</span>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-sm-4">
              <h5>Correo electrónico</h5>
              <span>{{ investor.email }}</span>
            </div>
            <div class="col-sm-4">
              <h5>Teléfono</h5>
              <span>{{ investor.telephone || 'no ingresado' }}</span>
            </div>
            <div class="col-sm-4">
              <h5>Celular</h5>
              <span>{{ investor.mobile || 'no ingresado' }}</span>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-sm-4">
              <h5>Fecha de nacimiento</h5>
              <span>{{ investor.dob | reverseDate }}</span>
            </div>
            <div class="col-sm-4">
              <h5>CURP</h5>
              <span>{{ investor.curp || 'no ingresado' }}</span>
            </div>
            <div class="col-sm-4">
              <h5>Tipo</h5>
              <span>{{ investor.type }}</span>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-sm-4">
              <h5>Nacionalidad</h5>
              <span>{{ investor.nationality }}</span>
            </div>
            <div class="col-sm-4">
              <h5>Promotor</h5>
              <span>{{ investor.promoter_name || 'no asignado' }}</span>
            </div>
            <div class="col-sm-4" v-if="investor.type == 'Moral'">
              <h5>Representante Legal</h5>
              <span>{{ investor.fullname }}</span>
            </div>
          </div>
          <hr class="mt-4"/>
          <div class="row"  v-if="investor.fiscal_data">
            <div class="col">
              <h4 class="m--font-info">Datos fiscales</h4>
            </div>
          </div>
          <div class="row mt-4" v-if="investor.fiscal_data">
            <div class="col-sm-4">
              <h5>RFC</h5>
              <span>{{ investor.fiscal_data.rfc || 'no ingresado' }}</span>
            </div>
            <div class="col-sm-4">
              <h5>Calle</h5>
              <span>{{ investor.fiscal_data.street || 'no ingresado' }}</span>
            </div>
            <div class="col-sm-4">
              <h5>Numero</h5>
              <span>{{ investor.fiscal_data.number || 'no ingresado' }}</span>
            </div>
          </div>
          <div class="row mt-4" v-if="investor.fiscal_data">
            <div class="col-sm-4">
              <h5>Colonia</h5>
              <span>{{ investor.fiscal_data.neighborhood || 'no ingresado' }}</span>
            </div>
            <div class="col-sm-4">
              <h5>Ciudad</h5>
              <span>{{ investor.fiscal_data.city || 'no ingresado' }}</span>
            </div>
            <div class="col-sm-4">
              <h5>Estado</h5>
              <span>{{ investor.fiscal_data.state || 'no ingresado' }}</span>
            </div>
          </div>
          <hr v-if="investor.fiscal_data">
          <div class="row">
            <div class="col-sm-12">
              <h4 class="m--font-info">Registro</h4>
            </div>
            <div class="col-sm-6 mt-4">
              <h5>Registrado por:</h5>
              <span>{{ investor.creator_name || 'Admin' }}</span>
            </div>
            <div class="col-sm-6 mt-4">
              <h5>Fecha de registro en el sistema:</h5>
              <span>{{investor.created_at}}</span>
            </div>
          </div>
        </div>
        <!--end: Details -->
        <!--begin: Bank_Data -->
        <div id="bank_data" class="tab-pane fade" role="tabpanel" v-if="investor.id">
          <sys-table :headers="bank_data_headers" :items="bank_data" :delete_action="deleteBankData" :edit_action="editBankData" title="Datos Bancarios" :create_route="bank_data_create" :create_route_params="bank_data_create_params" error_message="No se encontraron datos bancarios"/>
        </div>
        <!--end: Bank_Data -->
        <!--begin: Contacts -->
        <div id="contacts" class="tab-pane fade" role="tabpanel" v-if="investor.id">
          <sys-table :headers="contacts_headers" :items="contacts" :delete_action="deleteContact" :edit_action="editContact" title="Contactos" :create_route="contacts_create" :create_route_params="contacts_create_params" error_message="No se encontraron datos de contacto"/>
        </div>
        <!--end: Contacts -->
        <!--begin: Documentation -->
        <div id="documentation" class="tab-pane fade" role="tabpanel" v-if="investor.id">
          <investor-files :investor_files.sync="files" :file_categories="file_categories" />
        </div>
        <!--end: Documentation -->
        <!--begin: Investments -->
        <div id="investments" class="tab-pane fade" role="tabpanel" v-if="investor.id">
          <div class="row pb-5">
            <sys-widget title="Total de Contractos" :content="contracts.length" icon="user" color="secondary"/>
            <sys-widget title="Total de Anexos" :content="investor.investments_count" icon="info" color="secondary"/>
            <sys-widget title="Monto de Inversion" :content="investor.investments_amount | formatCurrency" icon="dollar-sign" color="secondary" />
            </div>
            <sys-table :headers="contracts_headers" :items="contracts" title="Inversiones" :detail_route="contract_detail" error_message="No se encontraron inversiones" :title_icon="['far','file']"/>
          </div>
          <!--end: Investments -->
          <!--begin: Monthly cuts -->
          <div id="monthly-cuts" class="tab-pane fade" role="tabpanel" v-if="investor.id">
            <sys-table :headers="monthly_cuts_headers" :items="monthly_cuts" title="Estados de cuenta" error_message="No se encontraron estados de cuenta" title_icon="dollar-sign"/>
          </div>
          <!--end: Monthly cuts -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import investorService from '@/services/investors'
import SysTable from '@/components/shared/Table'
import SysWidget from '@/components/shared/Widget'
import formatCurrency from '@/filters/formatCurrency'

import InvestorFiles from '@/components/investors/InvestorFiles'

export default {
  components: { SysTable, SysWidget, InvestorFiles },

  data () {
    return {
      bank_data_create: 'investor_bank_data_create',
      bank_data_create_params: {
        investor_id: this.$route.params.id
      },
      investor: {},
      bank_data_headers: [
        { text: 'Id', value: 'id' },
        { text: 'Clave Dispersión', value: 'clave_id' },
        { text: 'Cuenta Habiente', value: 'holder' },
        { text: 'Banco', value: 'bank' },
        { text: 'Cuenta', value: 'account' },
        { text: 'CLABE', value: 'clabe' }
      ],
      bank_data: [],
      contacts_headers: [
        { text: 'Nombre', value: 'name' },
        { text: 'Correo electrónico', value: 'email' },
        { text: 'Celular', value: 'telephone' },
        { text: 'Teléfono', value: 'mobile' },
        { text: 'Puesto', value: 'role' }
      ],
      contacts: [],
      contacts_create: 'investor_contact_create',
      contacts_create_params: {
        investor_id: this.$route.params.id
      },
      contract_detail: 'contract',
      contracts_headers: [
        { text: 'Id', value: 'id' },
        { text: 'Folio', value: 'folio' },
        { text: 'Total Anexos', value: 'attachments_count' },
        { text: 'Total Monto', value: 'amount', filter: formatCurrency },
        { text: 'Fecha Inicio', value: 'date_init' },
        { text: 'Interes (%)', value: 'interest_rate' },
        { text: 'Fecha Corte', value: 'cut_day' }
      ],
      investments: [],
      monthly_cut_route: 'monthly_cut',
      monthly_cuts_headers: [
        { text: 'Id', value: 'id' },
        { text: 'Anexos', value: 'attachment_count' },
        { text: 'Monto', value: 'amount', filter: formatCurrency },
        { text: 'Interés Bruto', value: 'gross_interest', filter: formatCurrency },
        { text: 'ISR', value: 'retention', filter: formatCurrency },
        { text: 'Interés Neto', value: 'net_interest', filter: formatCurrency },
        { text: 'Fecha de Corte', value: 'end_date' },
        { text: 'Edo 1', value: 'statement', link: false, statement: true, class: 'text-center' },
        { text: 'Edo 2', value: 'statement2', link: false, statement: true, class: 'text-center' }
      ],
      monthly_cuts: [],
      files: [],
      file_categories: []
    }
  },
  created: function () {
    const id = this.$route.params.id
    let element = this.$store.getters.getSelectedElement

    if (element.type === 'investor' && element.data.id === id) this.investor = element.data
    else {
      investorService.getById(id).then(res => {
        this.investor = res.data
        this.bank_data = res.data.bank_data
        this.contacts = res.data.contacts
        this.contracts = res.data.contracts
        this.monthly_cuts = res.data.monthly_cuts
        this.file_categories = res.data.investor_file_categories
        this.files = res.data.files
      })
    }
  },
  methods: {
    goToEdit () {
      const id = this.$route.params.id
      this.$router.push({ name: 'investor_update', params: { id } })
    },

    deleteInvestor () {
      const id = this.$route.params.id

      this.$swal({
        title: 'Deseas borrar el acreedor?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((willDelete) => {
        if (willDelete) {
          investorService.deleteById(id).then(res => {
            this.$swal('El Acreedor ha sido eliminado', {
              icon: 'success'
            })
            this.$router.push({ name: 'investors' })
          }).catch(err => {
            this.$swal(err.message, 'Favor de intentar nuevamente', {
              icon: 'error'
            })
          })
        }
      })
    },

    deleteContact (contactId) {
      let investorId = this.$route.params.id
      let component = this

      this.$swal({
        title: 'Deseas borrar contacto?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((willDelete) => {
        if (willDelete) {
          investorService.deleteContact(investorId, contactId).then(res => {
            component.contacts = component.contacts.filter(contact => {
              return contact.id != contactId
            })
            this.$swal('Contacto ha sido eliminado', {
              icon: 'success'
            })
          }).catch(err => {
            this.$swal(err.message, 'Favor de intentar nuevamente', {
              icon: 'error'
            })
          })
        }
      })
    },

    editContact (contactId) {
      this.$router.push({ name: 'investor_contact_edit',
        params: {
          contact_id: contactId, investor_id: this.$route.params.id
        } })
    },

    editBankData (bankId) {
      this.$router.push({ name: 'investor_bank_data_edit',
        params: {
          bank_id: bankId, investor_id: this.$route.params.id
        } })
    },

    deleteBankData (bankDataId) {
      let component = this

      this.$swal({
        title: 'Deseas borrar la cuenta?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((willDelete) => {
        if (willDelete) {
          investorService.deleteBankData(bankDataId).then(res => {
            component.bank_data = component.bank_data.filter(bankData => {
              return bankData.id != bankDataId
            })
            this.$swal('La Cuenta ha sido eliminada', {
              icon: 'success'
            })
          }).catch(err => {
            this.$swal(err.message, 'Favor de intentar nuevamente', {
              icon: 'error'
            })
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/investors/InvestorDetail.vue